import { css } from "./SKT";

export const SKTForm = ({ children }) => {
  return (
    <form autocomplete="off" className={css("form-horizontal")}>
      {children}
    </form>
  );
};
